<template>

    <m-edit1/>

    <m-single-store-501 v-bind='{...{"storeLink":null,"productListType":"slider","productCardName":"mProductCard524","smCardName":"mProductCard524","postSliderCard":"mPostCard2","showStoreLastName":true,"postSwiperPerViewSM":1,"postSwiperPerViewMD":2,"postSwiperPerViewLG":3,"productSwiperPerViewSM":1.2,"productSwiperPerViewMD":2,"productSwiperPerViewLG":6},...{}}' :style='""' class="m-single-store-501" ></m-single-store-501>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleStore501 from '@moeinmdn/miw-alpha-components/src/package/MultipleStore/Single/SingleStore501/SingleStore501';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleStore501 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
